import {
  FAIL_GET_UBER_EATS_USERS_RESULTS,
  REQUEST_GET_UBER_EATS_USERS_RESULTS,
  SUCCESS_GET_UBER_EATS_USERS_RESULTS,
} from '../../../actions/entities/uberEats';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  return {
    ...state,
    data: action.list,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_UBER_EATS_USERS_RESULTS]: requestFetch,
  [SUCCESS_GET_UBER_EATS_USERS_RESULTS]: successFetch,
  [FAIL_GET_UBER_EATS_USERS_RESULTS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/uberEats/results.js